export function emptyStyle(cube: CubeNode, params?: FreeObjMap): void {
    if (cube.cubes.length == 0) {
        cube.getDropArea().addClass('empty');
    } else {
        cube.getDropArea().removeClass('empty');
    }
}
